var map = {
	"./arrow.svg": [
		8813,
		813
	],
	"./checkbox-stroke.svg": [
		416,
		416
	],
	"./circle-check-regular.svg": [
		3583,
		583
	],
	"./circle-check.svg": [
		3617,
		617
	],
	"./hamburger-icon.svg": [
		8438,
		438
	],
	"./hirings/hh.svg": [
		1639
	],
	"./job/school.png": [
		9715
	],
	"./lavina-button--down.svg": [
		869,
		869
	],
	"./logo.svg": [
		2835,
		835
	],
	"./logo_with-text.svg": [
		739,
		739
	],
	"./main/about_office-desk.png": [
		8476
	],
	"./main/about_office.png": [
		9528
	],
	"./main/development/mobile.png": [
		303
	],
	"./main/development/web.png": [
		8511
	],
	"./main/intro_phone.png": [
		3197
	],
	"./main/projects/agmk.png": [
		4741
	],
	"./main/projects/apexpizza.png": [
		7066
	],
	"./main/projects/bonito.png": [
		8918
	],
	"./main/projects/business-asia.png": [
		4762
	],
	"./main/projects/green-post.png": [
		9530
	],
	"./main/projects/l-factura.png": [
		9881
	],
	"./main/services/arrow-top-right.svg": [
		7563,
		563
	],
	"./main/team/default/khakim.png": [
		2632
	],
	"./main/team/default/muhammadayub.png": [
		6777
	],
	"./main/team/default/quonch.png": [
		7096
	],
	"./main/team/default/sohibjon.png": [
		8467
	],
	"./main/team/default/yaroslav.png": [
		7921
	],
	"./main/team/hover/khakim.png": [
		8442
	],
	"./main/team/hover/muhammadayub.png": [
		4688
	],
	"./main/team/hover/quonch.png": [
		5643
	],
	"./main/team/hover/sohibjon.png": [
		3671
	],
	"./main/team/hover/yaroslav.png": [
		8512
	],
	"./projects/agmk/_aim.png": [
		3818,
		818
	],
	"./projects/agmk/intro.png": [
		110,
		110
	],
	"./projects/agmk/list/website.png": [
		1856,
		856
	],
	"./projects/apexpizza/aim.png": [
		7486,
		486
	],
	"./projects/apexpizza/intro.png": [
		368,
		368
	],
	"./projects/apexpizza/list/app.png": [
		687,
		687
	],
	"./projects/apexpizza/list/website.png": [
		9798,
		798
	],
	"./projects/bonito/aim.png": [
		9096,
		96
	],
	"./projects/bonito/intro.png": [
		9820,
		820
	],
	"./projects/bonito/list/app.png": [
		9321,
		321
	],
	"./projects/bonito/list/website.png": [
		452,
		452
	],
	"./projects/business-asia/aim.png": [
		6282,
		282
	],
	"./projects/business-asia/intro.png": [
		3035,
		35
	],
	"./projects/business-asia/list/app.png": [
		5274,
		274
	],
	"./projects/business-asia/list/website.png": [
		9489,
		489
	],
	"./projects/green-post/aim.png": [
		3477,
		477
	],
	"./projects/green-post/intro.png": [
		6455,
		455
	],
	"./projects/green-post/list/website.png": [
		6446,
		446
	],
	"./projects/l-factura/aim.png": [
		746,
		746
	],
	"./projects/l-factura/intro.png": [
		5033,
		33
	],
	"./projects/l-factura/list/app.png": [
		1233,
		233
	],
	"./projects/l-factura/list/tg.png": [
		6064,
		64
	],
	"./projects/l-factura/list/website.png": [
		1005,
		5
	],
	"./socials/Telegram_(software)-Logo.wine.svg": [
		5298,
		298
	],
	"./socials/facebook.svg": [
		4050,
		50
	],
	"./socials/instagram.svg": [
		8830,
		830
	],
	"./socials/linkedin.svg": [
		2392,
		392
	],
	"./socials/telegram.svg": [
		2462,
		462
	],
	"./socials/twitter.svg": [
		9123,
		123
	],
	"./times__close.svg": [
		7309,
		309
	],
	"./top-right.svg": [
		437,
		437
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2358;
module.exports = webpackAsyncContext;